import { render, staticRenderFns } from "./contentModal.vue?vue&type=template&id=4d64452e&scoped=true"
import script from "./contentModal.vue?vue&type=script&lang=js"
export * from "./contentModal.vue?vue&type=script&lang=js"
import style0 from "./contentModal.vue?vue&type=style&index=0&id=4d64452e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d64452e",
  null
  
)

export default component.exports